import AddItemCard from './AddItemCard';
import AddItemCardContainer from './AddItemCard.container';

export default AddItemCardContainer(AddItemCard);
